import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable()
export class UserService extends BaseService<any> {

    admApi: string = environment.api + 'v1/users/adm';

    constructor(http: HttpClient) { super(http); }

    async getListUser() {
        const fullUri = this.admApi + '/list';
        return await this.http.get<any>(fullUri, { headers: this.getOptions() }).toPromise();
    }

    async getUserById(id) {
        const fullUri = this.admApi + `/getById/${id}`;
        return await this.http.get<any>(fullUri, { headers: this.getOptions() }).toPromise();
    }

    async saveOrUpdate(object, isEdit = false) {
        const json = JSON.stringify(object);
        const fullUri = this.admApi + '/create/';
        if (isEdit) {
            const fullUri = this.admApi + '/update/';
            return await this.http.put<any>(fullUri, json, { headers: this.getOptions() }).toPromise();
        }


        return await this.http.post<any>(fullUri, json, { headers: this.getOptions() }).toPromise();
    }

    async deleteUserById(id) {

        const fullUri = this.admApi + `/delete/${id}`;

        return await this.http.delete<any>(fullUri, { headers: this.getOptions() }).toPromise();
    }


}